export const localeConfig = {
  en: {
    domain: 'com',
    displayName: 'English',
    bigQueryCountry: 'UK',
  },
  cs: {
    domain: 'cz',
    displayName: 'Česky',
    bigQueryCountry: 'CZ',
  },
  ro: {
    domain: 'ro',
    displayName: 'Română',
    bigQueryCountry: 'RO',
  },
  pl: {
    domain: 'pl',
    displayName: 'Polski',
    bigQueryCountry: 'PL',
  },
  sk: {
    domain: 'sk',
    displayName: 'Slovenčina',
    bigQueryCountry: 'SK',
  },
  el: {
    domain: 'gr',
    displayName: 'Ελληνικά',
    bigQueryCountry: 'GR',
  },
  hu: {
    domain: 'hu',
    displayName: 'Magyar',
    bigQueryCountry: 'HU',
  },
  uk: {
    domain: 'com.ua',
    displayName: 'Українська',
    bigQueryCountry: 'UA',
  },
  sl: {
    domain: 'si',
    displayName: 'Slovenščina',
    bigQueryCountry: 'SI',
  },
  lt: {
    domain: 'lt',
    displayName: 'Lietuvių',
    bigQueryCountry: 'LT',
  },
} as const
